export const schedule = [
  {
    init: "08:00",
    end: "09:00",
    activities: [[{ title: "Credenciamento dos participantes" }]],
  },
  {
    init: "09:00",
    end: "09:45",
    activities: [[{ title: "O que é o Open source e a OpenDevUFCG" }]],
  },
  {
    init: "10:00",
    end: "12:00",
    activities: [
      [
        {
          title: "Investigando o VSCode: Dicas e Personalizações",
          info: "Túlio Araújo Cunha",
        },
        {
          title: "PDE: um ambiente personalizado de desenvolvimento",
          info: "Iago Tito Oliveira",
        },
      ],
      [
        {
          title: "Docker sem pantim!",
          info: "Sérgio Duarte",
        },
      ],
      [
        {
          title: "Introdução a HTML, CSS E JS",
          info: "Marian Dela-Bianca e Leandra de Oliveira",
        },
      ],
      [
        {
          title: "Música e dados: uma tour interativa de dataviz",
          info: "Júlio Guedes e Matheus Alves",
        },
      ],
      [
        {
          title:
            "Como construir uma API? Introdução a API's Rest com Java e Spring Boot",
          info: "Izabella Ribeiro e Maria Eduarda de Azevedo",
        },
      ],
    ],
  },
  {
    init: "12:00",
    end: "13:00",
    activities: [
      [
        {
          title: "Pausa para almoço + Foto oficial",
          info: "Almoço não incluso",
        },
      ],
    ],
  },
  {
    init: "13:00",
    end: "16:00",
    activities: [
      [
        {
          title: "React hooks: Criando uma lib de forms nativa",
          info: "José Renan Silva Luciano",
        },
        {
          title: "Descomplicando o Figma e o autolayout",
          info: "Vanessa Fernandes",
        },
      ],
      [
        {
          title: "Construindo um projeto React com a API Web do Spotify",
          info: "Robson Jr.",
        },
        {
          title: "Construindo seu portifólio com Angular",
          info: "Mirlla Marques Santana Alves",
        },
      ],
      [
        {
          title: "Areas de infraestrutura: tem mais de uma?",
          info: "Marta Laís",
        },
        {
          title: "Guia de boas práticas de segurança para aplicações web",
          info: "Raisson Souto",
        },
      ],
      [
        {
          title: "Desmistificando a Ciência de Dados",
          info: "Beatriz Andrade de Miranda",
        },
        {
          title: "Fazendo mágica com GraphQL",
          info: "Nicolas Lopes Aquino",
        },
      ],
      [
        {
          title: "Primeiros passos na Raspagem de Dados",
          info: "Emily Albuquerque",
        },
        {
          title: "Desvendando o Chatbot com o Dialogflow",
          info: "João Henrique Almeida Xavier",
        },
      ],
    ],
  },
  {
    init: "16:00",
    end: "16:30",
    activities: [
      [
        {
          title: "Coffee break",
          info: "Patrocinado pelo evento",
        },
      ],
    ],
  },
  {
    init: "16:30",
    end: "17:30",
    activities: [
      [
        {
          title: "Encerramento do evento + projetos open source",
        },
      ],
    ],
  },
];
